import Customers              from 'scripts/defa/customers/collection-customers';
import CustomerController     from 'scripts/defa/customers/controller-customer-controller';
import Customer               from 'scripts/defa/customers/model-customer';
import CustomerRouter         from 'scripts/defa/customers/router-customer-router';
import CustomerCollectionView from 'scripts/defa/customers/view-customer-collection-view';
import CustomerContainer      from 'scripts/defa/customers/view-customer-container';
import CustomerCreateForm     from 'scripts/defa/customers/view-customer-create-form';
import CustomerSnippet        from 'scripts/defa/customers/view-customer-snippet';
import CustomerUpdateForm     from 'scripts/defa/customers/view-customer-update-form';
import Module                 from 'scripts/module';

const CustomerModule = new Module('CustomerModule', {
	views: {
		CustomerUpdateForm,
		CustomerSnippet,
		CustomerCreateForm,
		CustomerCollectionView,
		CustomerContainer,
	},
	routers: {
		CustomerRouter
	},
	models: {
		Customer
	},
	controllers: {
		CustomerController
	},
	collections: {
		Customers
	}
});

export default CustomerModule